var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightOptEng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 641 134.9",
    style: {
      enableBackground: "new 0 0 641 134.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174,43.5h-19.3v45.9h-21.8l0.1-0.3h18.9V43.2h22.2L174,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.2,43.2c2.8,0,3.8,0.9,3.8,2.4c0,0.8-0.3,1.8-0.7,2.8l-5.1,11.8h-0.3l5.1-11.8c0.4-0.9,0.7-2,0.7-2.8 c0-1.4-0.9-2.2-3.6-2.2h-12.3c-2.5,0-3.8,2.6-4.8,5l-15.2,35.6c-0.6,1.3-1.1,2.7-1.1,3.6c0,0.9,0.4,1.4,1.5,1.4h12.3 c4.3,0,6.1-2.6,7.2-5l5-11.8h0.3l-5,11.8c-1.3,3.2-3.4,5.3-7.6,5.3h-12.3c-2.8,0-3.8-0.9-3.8-2.4c0-0.9,0.3-1.8,0.8-2.9l15.2-35.6 c1.3-3.1,3.2-5.3,7.5-5.3H202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226,70.4c0.6-1.3,1.1-2.6,1.1-3.6c0-0.9-0.4-1.4-1.6-1.4h-17l-10.4,24h-2.6l19.9-46.2h14.3 c2.8,0,3.7,0.9,3.7,2.4c0,0.9-0.3,1.8-0.7,2.9l-7.1,16.6c2.8,0,3.8,0.9,3.8,2.4c0,0.8-0.3,1.8-0.8,2.8l-8.2,19h-2.6L226,70.4z  M230.1,48.5c0.6-1.3,1.1-2.6,1.1-3.6c0-0.9-0.4-1.4-1.6-1.4h-11.7l-9.3,21.6h14.3L230.1,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.1,77.4c0-3.2,0.7-7.1,2.1-11.1c4.6-13.1,14.3-23.7,26.4-23.7c8.5,0,11.9,5.1,11.9,12.5 c0,3.4-0.7,7.2-2.1,11.2C268,79.4,258.3,90,246.1,90C237.6,90,234.1,84.9,234.1,77.4z M235.8,79.2c0,6.3,3,10.5,9.6,10.5 c10.5,0,19.6-10.5,24.5-23.4c1.9-4.9,2.9-9.5,2.9-13.3c0-6.1-3.2-10.1-9.6-10.1c-10.5,0-19.6,10.5-24.6,23.4 C236.9,71.1,235.8,75.5,235.8,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.6,89.2l-0.1,0.3h-18.3l19.7-46.2h2.6l-19.3,45.9H287.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.2,89.2l-0.1,0.3h-18.3l19.7-46.2h2.6l-19.3,45.9H311.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.5,70.5c0.6-1.3,1.1-2.6,1.1-3.6c0-0.9-0.4-1.4-1.6-1.4h-17l-10.4,24h-2.6l19.9-46.2h14.3 c2.8,0,3.7,0.9,3.7,2.4c0,0.9-0.3,1.8-0.7,2.9l-7.1,16.6c2.8,0,3.8,0.9,3.8,2.4c0,0.8-0.3,1.8-0.8,2.8l-8.2,19h-2.6L359.5,70.5z  M363.6,48.6c0.6-1.3,1.1-2.6,1.1-3.6c0-0.9-0.4-1.4-1.6-1.4h-11.7l-9.3,21.6h14.3L363.6,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.3,89.5h-2.4l19.7-46.2h2.5L364.3,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402.4,66.4h2.6l-13.6,31.4l-1.5-2.6l2.5-5.7h-15c-2.7,0-3.7-0.9-3.7-2.4c0-0.8,0.3-1.8,0.8-2.9l15.3-35.6 c1.3-3.1,3.2-5.3,7.5-5.3h12.3c2.8,0,3.8,0.9,3.8,2.4c0,0.8-0.3,1.8-0.7,2.8l-2.6,5.9h-0.3l2.6-5.9c0.4-0.9,0.7-1.8,0.7-2.6 c0-1.4-0.8-2.4-3.5-2.4h-12.3c-2.5,0-3.8,2.6-4.8,5l-15.4,35.6c-0.6,1.3-1.1,2.6-1.1,3.6c0,0.9,0.5,1.4,1.6,1.4h15L402.4,66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.9,43.3h2.5L414.8,66h22.3l9.7-22.7h2.5l-19.7,46.2h-2.4l9.8-23.2h-22.3l-9.9,23.2h-2.4L421.9,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.4,43.5h-14.5l0.1-0.3h31.6l-0.1,0.3H471l-19.5,45.9h-2.6L468.4,43.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightOptEng);
export default __webpack_public_path__ + "static/media/right-opt_eng.21d8e2553c525b646baeab2f4ec859d3.svg";
export { ForwardRef as ReactComponent };